import styled from 'styled-components';

const TopWrapper = styled.div`
  position: relative;
  margin-bottom: 30px;
  font-family: 'Roboto';

  .title {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 15px;

    span {
      font-weight: 700;
      font-size: ${(p) => p.theme.fontSizes.base};
      line-height: 19px;
      color: ${(p) => p.theme.colors.gray500};
    }
  }

  .link {
    position: absolute;
    right: 0;
    top: 5px;
    a {
      color: ${(p) => p.theme.colors.primary500};
      text-decoration: underline;
    }
  }

  .text {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 10px;
  background: #e9e9e9;
  border-radius: 5px;
  margin-top: 10px;

  > div {
    display: flex;
    height: 100%;
    background: ${(p) => p.theme.colors.gray100};
    border-radius: 5px;
    overflow: hidden;
  }

  .orange {
    background: ${(p) => p.theme.colors.orange};
  }

  .green {
    background: ${(p) => p.theme.colors.secondary400};
  }

  .blue {
    background: ${(p) => p.theme.colors.primary500};
  }
`;

const TypeDot = styled.div<{ color: string }>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${(p) => {
    if (p.color === 'orange') return p.theme.colors.orange;
    if (p.color === 'blue') return p.theme.colors.primary500;
    return p.theme.colors.secondary400;
  }};
`;

export { TopWrapper, ProgressBar, TypeDot };
